import React from 'react'
import {FormFeedback, Label} from "reactstrap";

const renderCheck = ({ input, label, type, meta: { touched, error }, disabled }) => (

    <Label check>
        <input {...input} type={type} disabled={disabled} className={`form-check-input ${(touched && error) ? "is-invalid" : ""}`} style={{color: "#000000"}}/>
        { label }
        {touched && error && <div className="invalid-feedback" style={{display: "block"}}>{error}</div>}
    </Label>
)

export default renderCheck;


// WEBPACK FOOTER //
// ./src/renderCheck.js